<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-warning" subtitulo="Editar fornecedor"
             col-md="col-md-8" offset="offset-3">
    <template v-slot:modalContent>
      <form ref="editarForm" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.personalidade"
                    inputId="personalidade"
                    :options="tipoPessoa"
                    optionLabel="label"
                    optionValue="value"
                    @change="alterarMascara"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('personalidade')"
                />
                <label for="personalidade">
                  <strong>Tipo Pessoa:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <InputGroup size="small">
                <FloatLabel variant="on">
                  <InputMask id="cpf_cnpj" v-model="dado.cpf_cnpj" size="small" style="width: 100%"
                             :mask="dado.personalidade === 'PF' ? '999.999.999-99' : '99.999.999/9999-99'"
                             :invalid="campoVazio.includes('cpf_cnpj')"/>
                  <label for="cpf_cnpj"><strong>CPF/CNPJ: <span class="text-danger font-bold">*</span></strong></label>
                </FloatLabel>
                <InputGroupAddon>
                  <Button icon="pi pi-search" severity="secondary" variant="text" size="small" @click="handleBlur"/>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="razao_social" v-model="dado.razao_social" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('razao_social')"/>
                <label for="razao_social"><strong>Nome Completo/Razão Social: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="fantasia" v-model="dado.fantasia" size="small" style="width: 100%"/>
                <label for="fantasia"><strong>Nome Fantasia: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <InputGroup size="small">
                <FloatLabel variant="on">
                  <InputMask id="cep" v-model="dado.cep" size="small" style="width: 100%" mask="99999-999"
                             :invalid="campoVazio.includes('cep')"/>
                  <label for="cep"><strong>CEP: <span class="text-danger font-bold">*</span></strong></label>
                </FloatLabel>
                <InputGroupAddon>
                  <Button icon="pi pi-search" severity="secondary" variant="text" size="small" @click="cepClick"/>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
          <div class="col-md-7">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="endereco" v-model="dado.endereco" size="small" style="width: 100%"/>
                <label for="endereco"><strong>Endereço: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="numero" v-model="dado.numero" size="small" style="width: 100%"/>
                <label for="numero"><strong>Número: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="complemento" v-model="dado.complemento" size="small" style="width: 100%"/>
                <label for="complemento"><strong>Complemento: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="bairro" v-model="dado.bairro" size="small" style="width: 100%"/>
                <label for="bairro"><strong>Bairro: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="cidade" v-model="dado.cidade" size="small" style="width: 100%"/>
                <label for="cidade"><strong>Cidade: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="uf" v-model="dado.uf" size="small" style="width: 100%"/>
                <label for="uf"><strong>UF: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="email_pessoal" type="email" v-model="dado.email_pessoal" size="small"
                           style="width: 100%"/>
                <label for="email_pessoal"><strong>E-mail Pessoal: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="email_financeiro" type="email" v-model="dado.email_financeiro" size="small"
                           style="width: 100%"/>
                <label for="email_financeiro"><strong>E-mail Financeiro: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="email_comercial" type="email" v-model="dado.email_comercial" size="small"
                           style="width: 100%"/>
                <label for="email_comercial"><strong>E-mail Comercial: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputMask id="telefone" v-model="dado.telefone" size="small" style="width: 100%"
                           mask="(99) 9.9999-9999" :invalid="campoVazio.includes('telefone')"/>
                <label for="telefone"><strong>Telefone: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.status"
                    inputId="status"
                    :options="status"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('status')"
                />
                <label for="status">
                  <strong>Status: <span class="text-danger font-bold">*</span></strong>
                </label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {alterar_mascara} from '@/../public/js/scripts/personalidade';
import {buscarCnpj} from '@/../public/js/api/buscar_cnpj';
import {buscarCep} from '../../../public/js/api/buscar_cep';
import {apiRequest, cpfValido} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";
import {toastMessage} from "@/utils/appInstance";


export default {
  name: "EditarFornecedor",
  components: {
    BaseModal,
  },
  props: {
    itemKey: String,
  },
  data() {
    return {
      dado: 1,
      erro: null,
      isCpfReadonly: true,
      campoVazio: [],
      tipoPessoa: [
        {label: 'PESSOA FÍSICA', value: 'PF'},
        {label: 'PESSOA JURÍDICA', value: 'PJ'}
      ],
      status: [
        {label: 'ATIVO', value: 'A'},
        {label: 'INATIVO', value: 'I'}
      ],
    }
  },
  emits: ["fechar", "atualizarDados"],
  methods: {
    alterarMascara() {
      const {isCpfReadonly} = alterar_mascara(this.dado.personalidade);
      this.isCpfReadonly = isCpfReadonly;
    },
    handleBlur() {
      if (this.dado.personalidade === 'PF') {
        this.checkCPF();
      } else {
        this.cnpjBlur();
      }
    },
    checkCPF() {
      if (!cpfValido(this.dado.cpf_cnpj)) {
        toastMessage("warn", "Atenção", "CPF inválido, Digite um CPF válido.");
      }
    },
    async cepClick() {
      await buscarCep(this.dado.cep, this.dado)
    },
    async cnpjBlur() {
      if (this.dado.personalidade === "PJ") {
        await buscarCnpj(this.dado.cpf_cnpj, this.dado)
      }
    },
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.fornecedores.retrieveUpdateDestroy(this.itemKey)}?modo=edit`);
      if (resultado.success) {
        this.dado = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      const resultado = await apiRequest("PATCH", apiUrl.fornecedores.retrieveUpdateDestroy(this.itemKey), this.dado);
      if (resultado.success) {
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Atenção", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
